import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { AdminBetaSignups } from 'containers'

export const AdminBetaSignupsRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminBetaSignups />} />
    </Routes>
  )
}
